import { createSlice } from '@reduxjs/toolkit';

import { type MonarchRequest, type Rules } from '@core/hooks/monarch/monarch';

export const monarchSlice = createSlice({
  name: 'monarch',
  initialState: {} as Rules,
  reducers: {
    setTestResults: (_state, action) => ({ ...action.payload }),
  },
});

// Action
export const { setTestResults } = monarchSlice.actions;

// Getters
export const selectTestResultById = (state: any, id: MonarchRequest['id']) => state.monarch[id];

export const selectAllTestResults = (state: any): Rules => state.monarch;
// Reducer
export default monarchSlice.reducer;
